import { styled } from '@mui/material/styles';

export const StyledDetails = styled('p')`
  white-space: normal;
  word-break: normal;
  font-size: ${({ theme }) => theme.spacing(1.5)};
  line-height: ${({ theme }) => theme.spacing(2)};
`;
